<template>
  <TransitionRoot as="template" :show="isOpen">
    <Dialog as="div" class="relative z-[999]" @close="onClose">
      <div class="fixed top-0 inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full"
          >
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-250"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-250"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
              @after-enter="onAfterEnter"
            >
              <DialogPanel
                class="pointer-events-auto relative w-screen max-w-[420px]"
              >
                <div class="flex h-full flex-col overflow-auto bg-primary">
                  <div
                    class="flex items-center sticky top-0 bg-primary z-1 px-4 pt-4"
                  >
                    <div class="ui-text-xs text-white uppercase">
                      <span v-if="appliedFiltersCount">
                        {{
                          $t("filtersSelectedCount", {
                            count: appliedFiltersCount,
                          })
                        }}
                      </span>
                      <template v-else>
                        <span class="max-lg:hidden">
                          {{ $t("allFilters") }}
                        </span>
                        <span class="lg:hidden">
                          {{ $t("filterAndSort") }}
                        </span>
                      </template>
                      <span>
                        ({{ $t("amountProducts", { count: productsCount }) }})
                      </span>
                    </div>
                    <UiButton
                      class="text-white ml-auto"
                      variant="clear"
                      variant-type="icon"
                      size="xs"
                      :aria-label="$t('close')"
                      @click="onClose"
                    >
                      <UiIcon name="close" class="size-6" />
                    </UiButton>
                  </div>
                  <slot />
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

const props = defineProps<{
  modelValue: boolean;
  appliedFiltersCount: number;
  productsCount: number;
}>();

const emit = defineEmits(["update:modelValue"]);

const generalInternalStore = useGeneralInternalStore();

const isOpen = computed<boolean>({
  set(val) {
    emit("update:modelValue", val);
  },
  get() {
    return props.modelValue;
  },
});

watch(
  () => props.modelValue,
  (val) => {
    generalInternalStore.systemOverlay = val;
  },
);

function onAfterEnter() {
  setTimeout(() => {
    const inertEl = document.querySelector("[inert]");
    if (inertEl) {
      inertEl.removeAttribute("inert");
    }
  }, 0);
}

function onClose() {
  generalInternalStore.systemOverlay = false;
  isOpen.value = false;
}

onBeforeUnmount(() => {
  onClose();
});
</script>
